import { TrevorIconName } from '@trevor/ui-components';
import {
  hasZaps,
  isGoogleSheetsSharable,
  isOtherShareable,
} from '@/views/SavedQueries/helpers';
import { SHARE_OPTION } from '@/features/share-modal/ShareModal.constants';
import { ConnectedToolsButtonsProps } from './index';

type TagsData = (
  meta: ConnectedToolsButtonsProps['meta'],
  dashboardsById: ConnectedToolsButtonsProps['dashboardsById'],
  onShare: ConnectedToolsButtonsProps['onShare'],
  onNavigateToDashboard: ConnectedToolsButtonsProps['onNavigateToDashboard'],
) => {
  iconName: TrevorIconName;
  text: string;
  onClick: F0;
}[];

export const transformMetaToButtonsData: TagsData = (
  meta,
  dashboardsById,
  onShare,
  onNavigateToDashboard,
) =>
  [
    isGoogleSheetsSharable(meta)
      ? {
          iconName: 'google-sheets' as TrevorIconName,
          text: 'Google Sheets',
          onClick: onShare(SHARE_OPTION.googleSheets),
        }
      : [],
    meta.emailDestinations()?.map((text) => ({
      iconName: 'envelope' as TrevorIconName,
      text,
      onClick: onShare(SHARE_OPTION.email),
    })) ?? [],
    meta.slackDestinations()?.map((text) => ({
      iconName: 'slack' as TrevorIconName,
      text,
      onClick: onShare(SHARE_OPTION.slack),
    })) ?? [],
    meta.dashboardIds()?.map((text) => ({
      iconName: 'dashboard' as TrevorIconName,
      text: dashboardsById[text].name(),
      onClick: () => onNavigateToDashboard(text),
    })) ?? [],
    hasZaps(meta)
      ? {
          iconName: 'zapier' as TrevorIconName,
          text: `${meta.zapierCount()} ${
            meta.zapierCount() === 1 ? 'zap' : 'zaps'
          }`,
          onClick: onShare(SHARE_OPTION.zapier),
        }
      : [],
    meta.bucketFeeds()?.map((text) => ({
      iconName: 'aws-s3' as TrevorIconName,
      text,
      onClick: onShare(SHARE_OPTION.s3bucket),
    })) ?? [],
    isOtherShareable(meta)
      ? {
          iconName: 'paper-plane' as TrevorIconName,
          text: 'Other tools',
          onClick: onShare(SHARE_OPTION.other),
        }
      : [],
  ].flat();
